// Deeplink Landing Page — constants
// Reference: TECHNICAL DESIGN DOCUMENT — Deeplink (Universal Link) Improvement v1.0

// --- Supported destinations (Section 1.2) ---
export const DESTINATIONS = {
  FUND_TAB: "fund_tab",
  FUND_INFO: "fund_info",
  ARTICLE: "article",
  OPEN_MF: "open_mf",
  OPEN_PVD: "open_pvd",
  SOFT_ONBOARD: "soft_onboard",
  FORGOT_CREDENTIALS: "forgot_credentials",
};

// Public destinations show Screen B fallback (with web link)
// Private destinations show Screen C fallback (download only, no web fallback)
export const PUBLIC_DESTINATIONS = [
  DESTINATIONS.FUND_TAB,
  DESTINATIONS.FUND_INFO,
  DESTINATIONS.ARTICLE,
];

export const PRIVATE_DESTINATIONS = [
  DESTINATIONS.OPEN_MF,
  DESTINATIONS.OPEN_PVD,
  DESTINATIONS.SOFT_ONBOARD,
  DESTINATIONS.FORGOT_CREDENTIALS,
];

// --- Platforms ---
export const PLATFORMS = {
  IOS: "ios",
  ANDROID: "android",
  DESKTOP: "desktop",
};

// --- Actions returned by /resolve (Section 4.1) ---
export const ACTIONS = {
  OPEN_APP: "open_app",
  OPEN_APP_LOGIN_FIRST: "open_app_login_first",
  REDIRECT_STORE: "redirect_store",
  REDIRECT_WEB: "redirect_web",
  SHOW_LANDING_PAGE: "show_landing_page",
};

// --- Screen states ---
// Per the agreed Figma design, mobile Screens A/B/C share an identical UI
// (spinner + "กรุณารอสักครู่..." + download link). The visual does not change
// based on whether the app is installed — that branch only affects whether
// the cpamapp:// scheme succeeds or the user must tap the download link.
export const SCREENS = {
  MOBILE_LANDING: "MOBILE",   // Mobile — Opening App / No App (same UI)
  DESKTOP_PUBLIC: "D",        // Desktop Public — QR landing
  DESKTOP_PRIVATE: "E",       // Desktop Private — QR landing
};

// --- UI strings (mobile landing) ---
// All three logical screens share these strings per the Figma design.
export const UI_STRINGS = {
  th: {
    headerAlliance: "In alliance with",
    langTh: "TH",
    langEn: "EN",
    title: "กรุณารอสักครู่...",
    subtitle: "กำลังเปิดแอป Principal TH!",
    downloadLink: "ดาวน์โหลด Principle TH app",
  },
  en: {
    headerAlliance: "In alliance with",
    langTh: "TH",
    langEn: "EN",
    title: "Please wait a moment...",
    subtitle: "Opening Principal TH!",
    downloadLink: "Download Principle TH app",
  },
};

// --- Firebase Analytics events (Section 3) ---
export const FIREBASE_EVENTS = {
  DEEPLINK_CLICK: "deeplink_click",
  CONTENT_VIEW: "content_view",
  APP_STORE_REDIRECT: "app_store_redirect",
  PRIVATE_JOURNEY_START: "private_journey_start",
  LOGIN_REQUIRED: "login_required",
  POST_LOGIN_CONVERSION: "post_login_conversion",
  QR_SCAN: "qr_scan",
  REGISTRATION_COMPLETE: "registration_complete",
};

// --- Custom URL scheme prefix ---
export const APP_SCHEME = "cpamapp://";

// --- Fallback timer (Section 7.4 — Step 4) ---
export const APP_OPEN_TIMEOUT_MS = 2000;

// --- App Store / Play Store URLs ---
// TODO: replace with the real Principal TH listing IDs once published
export const STORE_URLS = {
  IOS: "https://apps.apple.com/th/app/principal-th/id1503809362",
  ANDROID: "https://play.google.com/store/apps/details?id=th.co.cpam.b2c",
};

// --- Desktop public-mode web fallback URLs (Section 6.3) ---
// Used as the "ดูบนเว็บไซต์" button on Screen D for public destinations.
export const PUBLIC_WEB_URLS = {
  [/* fund_tab */ "fund_tab"]: "https://www.principal.th/fund-listing/th/all",
  // Fund Info / Article URLs depend on slug or fund code,
  // resolved at runtime from the /resolve response (web_url field).
};

// --- Desktop Screen D transition (Section 7.3) ---
// "A brief 1–2 second transition screen is shown before the page fully renders."
export const DESKTOP_TRANSITION_MS = 1500;

// --- QR Code size (in px) shown on Desktop Screen D / E ---
export const QR_CODE_SIZE = 240;

// --- Fallback QR generator (used if be-deeplink /qr-code is unavailable) ---
// We use a public QR image API so the page still renders during backend rollout.
// Replace with /deeplink/v1/qr-code once the backend is live.
export const QR_FALLBACK_SERVICE =
  "https://api.qrserver.com/v1/create-qr-code/";
